import { render } from "./FilePreview.vue?vue&type=template&id=5c07f15b&ts=true"
import script from "./FilePreview.vue?vue&type=script&lang=ts"
export * from "./FilePreview.vue?vue&type=script&lang=ts"

import "./FilePreview.vue?vue&type=style&index=0&id=5c07f15b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__